import React from "react";
import styled from "styled-components";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { EducationConference } from "../../images/svgs";
import RenderWhenReady from "../RenderWhenReady";

const Header = ({ image }) => {
  const background = getImage(image);
  return (
    <Container>
      <RenderWhenReady>
        <GatsbyImage image={background} alt="Adult & elderly person" />
      </RenderWhenReady>
      <Text>
        <Information>
          Saturday, April 25th, <span>11:00h - 14:00h</span>
        </Information>
        <H2>
          <EducationConference />
        </H2>
      </Text>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  margin-top: 3rem;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  position: relative;
  overflow: visible;
  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
  }
  @media (min-width: 768px) {
    justify-content: center;
  }
  @media (min-width: 1150px) {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    .gatsby-image-wrapper {
      height: auto;
    }
  }
`;

const Text = styled.div`
  position: relative;
  padding: 2rem 1.25rem;
  grid-column: 1/6;
  @media (min-width: 768px) {
    grid-column: 1/5;
    padding: 4.125rem 1.25rem 1.5rem 1.25rem;
  }
  @media (min-width: 1150px) {
    padding: 5.125rem 0 3rem 0;
    grid-column: 2/12;
  }
  @media (min-width: 1600px) {
    grid-column: 3/11;
  }
`;

const H2 = styled.h2`
  background: #e6f5ea;
  color: var(--abbvie-green);
  font-family: "League Spartan", sans-serif;
  font-style: normal;
  font-weight: 900;
  font-size: 32px;
  line-height: 36px;
  text-transform: uppercase;
  padding: 1rem;
  span {
    font-size: 1.5rem;
    line-height: 1.5rem;
  }
  @media (min-width: 768px) {
    font-size: 42px;
    line-height: 46px;
    span {
      font-size: 2.5rem;
      line-height: 2.75rem;
    }
  }
  @media (min-width: 1150px) {
    font-size: 6.375rem;
    line-height: 4.275rem;
    margin-bottom: 3rem;
    background: transparent;
    max-width: 680px;
    margin-bottom: 6rem;
    padding: 0;
    span {
      font-size: 3.875rem;
      line-height: 3.875rem;
    }
  }
`;

const Information = styled.h5`
  color: var(--abbvie-bright-green);
  font-family: "League Spartan", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  margin: 1rem 0;
  max-width: 50%;
  span {
    font-weight: 600;
  }
  @media (min-width: 768px) {
    font-size: 24px;
    line-height: 28px;
    max-width: 40%;
  }
  @media (min-width: 1150px) {
    font-size: 2.5rem;
    line-height: 2.75rem;
    margin: 2rem 0 3rem 0;
    max-width: 100%;
  }
`;

export default Header;
